<template>
  <div class="video-uploader">
    <v-card v-if="video" height="100%">
      <div v-if="label" class="video-uploader__label">
        <v-label>{{ label }}</v-label>
      </div>

      <v-icon
        v-if="!readonly"
        class="video-uploader__clear-btn"
        large
        :title="$t('common.fields.photo.clear')"
        @click="onClear"
      >
        mdi-delete-forever
      </v-icon>

      <div class="video-uploader__preview">
        <video ref="video" :src="video.link" :controls="false"></video>
        <v-icon
          class="video-uploader__play-btn"
          color="rgba(255, 255, 255, 0.7)"
          size="55"
          @click="
            () => {
              dialog.opened = true;
              dialog.src = video.link;
            }
          "
        >
          mdi-play-circle
        </v-icon>
      </div>
    </v-card>

    <v-card v-else height="100%" outlined :loading="uploading">
      <div v-if="label" class="video-uploader__label">
        <v-label>{{ label }}</v-label>
      </div>

      <div v-if="readonly" class="video-uploader__no-data">
        <v-icon large>mdi-video-off</v-icon>
        Нет видео
      </div>

      <button v-else class="video-uploader__upload" @click="onUploadClick">
        <v-icon large>mdi-upload</v-icon>
        Загрузить видео
      </button>

      <input
        ref="videoInput"
        class="video-uploader__input"
        type="file"
        accept="video/mp4,video/x-m4v,video/*"
        @change="onFileChange"
      />
    </v-card>

    <video-dialog v-model="dialog.opened" :src="dialog.src" />
  </div>
</template>

<script>
import VideoDialog from '@/components/shared/VideoDialog.vue';

export default {
  components: { VideoDialog },
  props: {
    video: {
      type: [Object, null],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    uploading: false,
    dialog: {
      opened: false,
      src: '',
    },
  }),
  methods: {
    onUploadClick(e) {
      this.$refs.videoInput.click();
      e.preventDefault();
    },
    onClear() {
      this.$refs.video.file = null;
      this.$emit('update:video', null);
    },
    async onFileChange(e) {
      const file = e.srcElement.files[0];

      if (!file) return;

      this.uploading = true;

      const formData = new FormData();
      formData.append('videos[]', file);

      const video = await this.$store.dispatch('global/uploadVideo', formData);

      this.$emit('update:video', video);
      this.uploading = false;
    },
  },
};
</script>

<style lang="scss">
.video-uploader {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &__upload,
  &__no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .v-icon {
      margin-right: 5px;
    }
  }

  &__label {
    position: absolute;
    font-size: 14px;
    top: 0px;
    left: 0px;
    width: 100%;
    padding: 11px;
    background-color: #e9e9e9e3;
    border-radius: 0px !important;
    z-index: 1;
    padding-right: 40px;
    line-height: 1.2;

    label {
      font-size: 14px;
    }
  }

  &__input {
    display: none;
  }

  &__preview {
    width: 100%;
    height: 100%;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__play-btn {
    position: absolute;
    margin-top: 15px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;

    &:hover {
      transform: translate(-50%, -50%) scale(1.2);
    }
  }

  &__clear-btn {
    position: absolute;
    right: 5px;
    top: 5px;
    color: #ffa726 !important;
    background: #fafafa69;
    border-radius: 0 !important;
    cursor: pointer;
    z-index: 1;
  }
}
</style>
